<template lang="pug">
#details-tab
  b-field(label="Publish" expanded)
  b-field(grouped)
    b-field
      b-switch(
        type="is-success"
        :value="event.is_published"
        @input="set($event, 'is_published')"
      )
    b-field(v-if="event.is_published" expanded)
      b-datepicker(
        icon="calendar-today"
        :date-formatter="tempFormatter"
        :value="event.pub_date"
        @input="set($event, 'pub_date')"
      )
  b-field(
    label="Title"
    :message="errors.has('title') ? errors.first('title') : ''"
    :type="errors.has('title') ? 'is-danger' : ''"
  )
    b-input(
      type="text"
      name="title"
      v-validate="'required'"
      :value="event.title"
      @input="setKey"
    )
  b-field(
    label="Event Page URL"
    :message="errors.has('url') ? errors.first('url') : ''"
    :type="errors.has('url') ? 'is-danger' : ''"
  )
    b-field(:type="errors.has('url') ? 'is-danger' : ''")
      p.control
        span.button.is-static {{ account.host }}/{{event.type}}s/
      b-input(
        type="text"
        name="url"
        v-validate="{ required: true, unique: { id: event.id, resource: 'events', fieldName: 'URL' } }"
        data-vv-delay="1000"
        :value="event.key"
        @input="set($event, 'key')"
        expanded
      )
  div(v-if="event.type === 'event'" style="margin-bottom:0.75rem;")
    b-field(
      label="Dates"
      :message="errors.has('dates') ? errors.first('dates') : ''"
      :type="errors.has('dates') ? 'is-danger' : ''"
    )
      event-date-select(
        name="dates"
        :value="event.dates"
        v-validate="'required'"
        @input="set($event, 'dates')"
      )
    b-field(label="Time" v-if="dateMode !== 'range'")
    b-field(grouped v-if="dateMode !== 'range'")
      b-timepicker(
        icon="clock"
        hour-format="12"
        name="start_time"
        :increment-minutes="15"
        :value="event.start_time"
        @input="set($event, 'start_time')"
      )
      b-timepicker(
        icon="clock"
        hour-format="12"
        name="start_time"
        :increment-minutes="15"
        :value="event.end_time"
        @input="set($event, 'end_time')"
      )
    b-field(label="Location")
      event-location-field(
        :value="locationLabel"
        @input="setLocationId"
      )
    b-field(label="Ministries")
      elasticsearch-multiselect(
        field="name"
        index="doxa_ministries"
        :value="event.ministry_ids"
        @input="set($event, 'ministry_ids')"
      )
  b-field(label="Preview")
    b-input(
      type="textarea"
      rows="2"
      :value="event.short_desc"
      @input="set($event, 'short_desc')"
    )
  b-field(label="Full Description")
    b-input(
      type="textarea"
      rows="5"
      :value="event.long_desc"
      @input="set($event, 'long_desc')"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import EventDateSelect from '@/components/form/EventDateSelect';
import EventLocationField from '@/components/form/EventLocationField';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'details-tab',
  components: {
    ElasticsearchMultiselect,
    EventDateSelect,
    EventLocationField,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      event: getters.GET_EVENT,
    }),
    dateMode() {
      let mode = 'date';
      if (this.event.dates.length === 2) {
        mode = 'range';
      } else if (this.event.dates.length > 2) {
        mode = 'dates';
      }
      return mode;
    },
    locationLabel() {
      if (this.event._embedded.location.id === undefined) return null;
      return this.event._embedded.location.label;
    },
  },
  inject: ['$validator'],
  methods: {
    tempFormatter(date) {
      const yyyyMMdd = [
        date.getFullYear(),
        (date.getMonth() + 1),
        date.getDate(),
      ].join('/');
      const d = new Date(yyyyMMdd);
      return d.toLocaleDateString();
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EVENT_FIELD, {
        key,
        val,
      });
    },
    setKey(val) {
      this.set(val, 'title');
      if (val !== undefined) {
        const slug = val.toString().toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '');
        const year = new Date().getFullYear();
        const key = `${slug}-${year}`;
        this.set(key, 'key');
        this.$validator.validate('url', key);
      }
    },
    setLocationId(val) {
      this.$store.commit(mutations.SET_EVENT_FIELD, {
        key: '_embedded.location.id',
        val,
      });
    },
  },
};
</script>

<style lang="scss">
#details-tab {
  .button {
    font-family: 'system-ui';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/event/DetailsTab.vue